import { types } from 'mobx-state-tree'

import { center_app_version } from 'version'

export const ReleaseInfoModel = types.model('ReleaseInfoModel').props({
  frontend_version: center_app_version.commit_sha,
  gcs_backend_version: types.string,
  oversight_backend_version: types.string,
})
